<template>
  <div class="flex items-center justify-center gap-2 h-full">
    <div class="w-5 h-5 rounded-full animate-pulse bg-blue-600"></div>
    <div class="w-5 h-5 rounded-full animate-pulse bg-blue-600"></div>
    <div class="w-5 h-5 rounded-full animate-pulse bg-blue-600"></div>
  </div>
</template>
